{
  "active": "Active",
  "pending_invite": "Pending invite",
  "deactivated": "Deactivated"
}
